import { IDisposable, editor, languages } from 'monaco-editor-core';
import { YARA_ID } from './constants';
import { grammar, config } from './yara';

export function setupMode(): IDisposable {
  const disposables: IDisposable[] = [];
  const providers: IDisposable[] = [];

  languages.setLanguageConfiguration(YARA_ID, config);

  editor.onDidCreateModel(model => {
    if (model.getLanguageId() !== YARA_ID) {
      return;
    }
  });

  return asDisposable(disposables);
}

function asDisposable(disposables: IDisposable[]): IDisposable {
  return { dispose: () => disposeAll(disposables) };
}

function disposeAll(disposables: IDisposable[]) {
  while (disposables.length) {
    disposables.pop()!.dispose();
  }
}

languages.register({
  id: YARA_ID,
});

languages.setMonarchTokensProvider(YARA_ID, grammar);

languages.onLanguage(YARA_ID, () => {
  setupMode();
});
